import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass, Style } from '../../../../style';

const cssPrefix = 'spaces-explorer';

export namespace ExplorerDropdownStyles {
  export const FlyoutButtonPanelContainer = cssClass(cssPrefix, 'flyout-button-panel-container', {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    paddingBottom: TabStyles!.Spacing!.MediumSpace,
    paddingTop: TabStyles!.Spacing!.MediumSpace,
    paddingRight: TabStyles!.Spacing!.DefaultSpace,
    paddingLeft: TabStyles!.Spacing!.DefaultSpace,
    fontSize: TabStyles!.Typography!.Sizing!.Default,
    fontFamily: TabStyles!.Typography!.FontFamily
  });

  const baseExplorerDropdownItemContainer: Style = {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'row',
    height: CommonStyles.Sizes.DropdownItemHeight,
    color: applyColor(DesignTokens.color.font.default.default, TabStyles!.Typography!.Color!.Primary),
    justifyContent: 'space-between',
    paddingRight: TabStyles!.Spacing!.DefaultSpace,
    paddingLeft: TabStyles!.Spacing!.DefaultSpace,
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };

  // expose the same layout styling as ExplorerDropdownItemContainer, but without any interactive styles, for use in List widgets
  export const ExplorerDropdownListItemContainer = cssClass(cssPrefix, 'explorer-dropdown-list-item-container', {
    ...baseExplorerDropdownItemContainer,
    paddingLeft: undefined,
    paddingRight: undefined,
  });

  export const ExplorerDropdownItemContainer = cssClass(cssPrefix, 'explorer-dropdown-item-container', {
    ...baseExplorerDropdownItemContainer,
    $nest: {
      '&:hover': {
        backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.hover, TabStyles!.Colors!.L2_5),
        color: applyColor(DesignTokens.color.font.default.default, TabStyles!.Typography!.Color!.Primary)
      }
    },
  });

  export const ExplorerDropdownSelectedItemContainer = cssClass(cssPrefix, 'explorer-dropdown-selected-item-container', {
    ...baseExplorerDropdownItemContainer,
    backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, TabStyles!.Colors!.L2_5),
    color: applyColor(DesignTokens.color.font.default.default, TabStyles!.Typography!.Color!.Primary)
  });

  export const ExplorerDropdownDisabledItemContainer = cssClass(cssPrefix, 'explorer-dropdown-disabled-item-container', {
    ...baseExplorerDropdownItemContainer,
    color: applyColor(DesignTokens.color.font.default.disabled, TabStyles!.Typography!.Color!.Disabled)
  });

  export const ExplorerDropdownItemHeaderContainer = cssClass(cssPrefix, 'explorer-dropdown-item-header-container', {
    ...baseExplorerDropdownItemContainer,
    color: applyColor(DesignTokens.color.font.default.disabled, TabStyles!.Typography!.Color!.Disabled)
  });

  export const ExplorerDropdownItemSeparator = cssClass(cssPrefix, 'explorer-dropdown-item-separator', {
    height: 1,
    backgroundColor: applyColor(DesignTokens.color.component.background.cta.default.disabled, TabStyles!.Colors!.L9Disabled),
    marginBottom: TabStyles!.Spacing!.DefaultSpace,
    marginTop: TabStyles!.Spacing!.DefaultSpace
  });

  export const ExplorerDropdownItemCheckandNameContainer = cssClass(cssPrefix, 'explorer-dropdown-item-check-and-name-container', {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'row'  });

  export const ExplorerDropdownCount = cssClass(cssPrefix, 'explorer-dropdown-count', {
    minWidth: 36,
    textAlign: 'right',
    marginLeft: TabStyles.Spacing.MediumSpace
  });

  const baseExplorerDropdownButton: Style = {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, 'white'),
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between'
  };

  export const ExplorerDropdownButton = cssClass(cssPrefix, 'explorer-dropdown-button', {
    ...baseExplorerDropdownButton,
    $nest: {
      '&:hover': {
        borderBottomColor: applyColor(DesignTokens.color.elevation.border.inverse.clear, TabStyles.Colors.Black)
      }
    },
    borderBottomColor: applyColor(DesignTokens.color.elevation.border.default.subtle, TabStyles.Colors.L6)
  });

  export const ExplorerDropdownButtonActive = cssClass(cssPrefix, 'explorer-dropdown-button-active', {
    ...baseExplorerDropdownButton,
    borderBottomColor: applyColor(DesignTokens.color.elevation.border.inverse.clear, TabStyles.Colors.Black)
  });

  export const ExplorerDropdownButtonDisabled = cssClass(cssPrefix, 'explorer-dropdown-button-disabled', {
    ...baseExplorerDropdownButton,
    borderBottomColor: applyColor(DesignTokens.color.component.border.neutral.default.disabled, TabStyles.Colors.F7Disabled)
  });

  export function explorerDropdownButtonClass(showingOrActive: boolean, disabled: boolean) {
    if (disabled) {
      return ExplorerDropdownButtonDisabled;
    }

    if (showingOrActive) {
      return ExplorerDropdownButtonActive;
    }

    return ExplorerDropdownButton;
  }

  export const ExplorerDropdownArrowImg = cssClass(cssPrefix, 'explorer-dropdown-arrow-img', {
    height: 9,
    width: 9,
    verticalAlign: 'bottom',
    marginLeft: TabStyles.Spacing.SmallSpace
  });

  export const ExplorerDropdownCheckImg = cssClass(cssPrefix, 'explorer-dropdown-check-img', {
    height: 10,
    width: 10,
    marginRight: TabStyles!.Spacing!.DefaultSpace
  });
}
